import Vue from 'vue'
import login from '@/page/login.vue'
import GuidePage from '@/page/Guide.vue'
import loginForget from '@/page/loginForget'
import register from '@/page/register'
import regResult from '@/page/registerResult'
import Router from 'vue-router'
import Wloader from '../page/wloader.vue'
import Hkloader from '../page/hkloader.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      // meta:{title: "会员登录"}
    },
    {
      path: '/guide',
      name: 'Guide',
      component: GuidePage,
      // meta:{title: "会员登录"}
    },
    {
      path: '/findpwd',
      name: 'loginForget',
      component: loginForget,
      // meta:{title: "会员登录"}
    },
    {
      path: '/register',
      name: 'register',
      component: register,
    },
    {
      path: '/reg_result',
      name: 'regResult',
      component: regResult,
    },
    {
      path: '/wloader',
      name: 'wloader',
      component: Wloader,
    },
    {
      path: '/hkloader',
      name: 'hkloader',
      component: Hkloader,
    },
  ],

});


// WEBPACK FOOTER //
// ./src/router/index.js